/* unplugin-vue-components disabled */import script from "./Notifications.vue?vue&type=script&setup=true&lang=js"
export * from "./Notifications.vue?vue&type=script&setup=true&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=7271b997&scoped=true&lang=css"
import "./Notifications.vue?vue&type=style&index=1&id=7271b997&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7271b997"]])

export default __exports__